import axios from "axios";

import http from "@web-app/utils/http";

export const uploadAvatar = async (payload: FormData) => {
  return http
    .post<string>("/avatar/upload", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);
};

export const uploadSpreadsheet = async (payload: FormData) => {
  return http
    .post<string>("/sheet/upload", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => response.data);
};

const getSignedUrl = async (payload: {
  contentType: string;
  fileName: string;
}) => {
  return http
    .post<{
      bucket: string;
      fileUrl: string;
      key: string;
      region: string;
      url: string;
    }>("/getSignedUrl", payload)
    .then((response) => response.data);
};

export const uploadToS3 = async (payload: File) => {
  const signedUrl = await getSignedUrl({
    contentType: payload.type,
    fileName: payload.name,
  });

  await axios.create().put(signedUrl.url, payload, {
    headers: {
      "Content-Type": payload.type,
    },
  });

  return signedUrl.fileUrl;
};
